import _get from "lodash/get";
import { POSTHOG_ANNOUNCEMENT_SUFFIX } from "../config";
export const isAnnouncementFlag = (flag) => flag.endsWith(POSTHOG_ANNOUNCEMENT_SUFFIX);
export const isValidMessage = (message) => {
    return typeof message === "string";
};
export const parseAnnouncementMessage = (payload) => {
    const message = _get(payload, "message", "");
    return isValidMessage(message) ? message : "";
};
